import Header from "./components/Header";
import BasicTabs from "./components/Tabs";

const App: React.FC = () => {
  return (
    <>
      <Header />
      <BasicTabs />
    </>
  );
};

export default App;
